import _setClasses from 'clsx';

export const setClasses = _setClasses;
export const extractClasses = ({ classes = {}, className = '', ...restProps } = {}, ...extraClasses) => {
	var finalClasses = setClasses(className, classes, ...extraClasses);
	if (finalClasses) restProps.className = finalClasses;
	return restProps;
};
